module.exports = __webpack_public_path__ + "0161c93a6575c8d98e0844cc09cfba7d.png";